
import React from "react";
import ResultLayout from "./ResultLayout";
import { useLocation, useNavigate } from "react-router-dom";
import { ResultIcon, KeyValueRow } from "./components";

export default function PaymentComplete() {
  const nav = useNavigate();
  const { search } = useLocation();
  const q = new URLSearchParams(search);

  // NICEPAY 표준 파라미터 예시(필요한 것만 표시)
  const orderId   = q.get("moid");
  const tid       = q.get("tid");         // 거래 ID
  const amt       = q.get("amt");         // 결제 금액
  const goodsName = q.get("goodsName");
  const buyerName = q.get("buyerName");
  const payMethod = q.get("payMethod");   // CARD, BANK, VBANK, etc.
  const resultMsg = q.get("resultMsg");

  return (
    <ResultLayout title="결제 완료">
      <div className="contents-wrap">
        <div className="text-cent" style={{padding:'24px 0 8px'}}>
          <ResultIcon type="success" />
          <h3 style={{marginBottom:4}}>결제가 성공적으로 처리되었습니다.</h3>
          <p className="sub-txt">{resultMsg || "정상 승인되었습니다."}</p>
        </div>

        <div className="lineTop_tb01 mt18">
          <table className="lineTop_tb2">
            <tbody>
              <KeyValueRow label="주문번호" value={orderId} />
              <KeyValueRow label="거래번호(TID)" value={tid} />
              <KeyValueRow label="상품명" value={goodsName} />
              <KeyValueRow label="결제자" value={buyerName} />
              <KeyValueRow label="결제수단" value={payMethod} />
              <KeyValueRow label="결제금액" value={amt && Number(amt).toLocaleString() + "원"} />
            </tbody>
          </table>
        </div>

        <div className="btn-wrap text-cent mt30">
          <button className="btn btn-blue" onClick={() => nav("/myLectures/myStudentLectures")}>내 신청내역 보러가기</button>
          <button className="btn btn-gray ml10" onClick={() => nav("/")}>홈으로</button>
        </div>
      </div>
    </ResultLayout>
  );
}
